import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DocumentAvailableRole } from 'gql-types';

export interface CompanyPickerPopupSliceInitialStateProps {
    isOpen: boolean;
    companyList: Array<DocumentAvailableRole>;
}

const initialState: CompanyPickerPopupSliceInitialStateProps = {
    isOpen: false,
    companyList: [],
};

export const companyPickerPopupSlice = createSlice({
    name: 'companyPickerPopupSlice',
    initialState,
    reducers: {
        setOpenPopup: (state) => {
            state.isOpen = true;
        },
        setClosePopup: (state) => {
            state.isOpen = false;
        },
        setCompanyList: (
            state,
            action: PayloadAction<
                CompanyPickerPopupSliceInitialStateProps['companyList']
            >,
        ) => {
            state.companyList = action.payload;
        },
    },
});

export const {
    setOpenPopup,
    setClosePopup,
    setCompanyList,
} = companyPickerPopupSlice.actions;

export default companyPickerPopupSlice.reducer;
